import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';

import { finishChecklist, getChecklistInfo, startChecklist } from '@/store/check-list/actions';

import { selectCheckList } from '@/store/check-list/selectors';
import { selectLMS } from '@/store/lms/selectors';
import { selectStudyPlan } from '@/store/study-plan/selectors';

import { Button, Spin, Typography } from 'antd';
import CheckListElement from '@/pages/CollectionMaterialsIDStudy/CheckList/parts/CheckListElement';

import style from './CheckList.module.scss';

import { FINISHED } from '@/constants/study-plan-statuses';

const CheckList = ({ block, getStatistic }) => {
  const dispatch = useDispatch();

  const { checkListInfo, isLoading } = useSelector(selectCheckList);
  const { statistic } = useSelector(selectLMS);
  const { studyPlanId } = useSelector(selectStudyPlan);

  const { t } = useTranslation('pokaChecklist');

  const next = statistic?.blocksStat && statistic.blocksStat.filter(item => item.status !== FINISHED).length;

  useEffect(() => {
    dispatch(getChecklistInfo(block.blockId, studyPlanId[0].id));

    if (block.isAvailableForStart) {
      dispatch(startChecklist(block.blockId));
    }
  }, [block]);

  const onFinish = () => {
    dispatch(finishChecklist(block.blockId, () => getStatistic(next <= 1)));
  };

  return (
    <div className={style['check-list']}>
      <Typography.Text className={style['check-list__text']} data-qa='checkListName'>
        {block?.name}
      </Typography.Text>
      {checkListInfo?.description && (
        <Typography.Text data-qa='checkListDescription'>{checkListInfo.description}</Typography.Text>
      )}
      <Spin spinning={isLoading}>
        {checkListInfo?.checklist?.map((item, index) => (
          <CheckListElement key={index} index={index + 1} {...item} />
        ))}
      </Spin>
      {block.status !== FINISHED && (
        <div className={style['check-list__footer']}>
          <Button onClick={onFinish} type='primary' data-qa='checkListFinishBtn'>
            {t('familiar')}
          </Button>
        </div>
      )}
    </div>
  );
};

export default CheckList;
